import { breakPoints } from './breakPoints';
const videoObserver = () => {
    const breakPoint = breakPoints.tablet;
    const switchMedia = (section, desktopVideo, mobileVideo) => {
        if (window.innerWidth < breakPoint) {
            if (mobileVideo && section.src !== mobileVideo) {
                section.src = mobileVideo;
            }
        }
        else {
            if (desktopVideo && section.src !== desktopVideo) {
                section.src = desktopVideo;
            }
        }
    };
    const init = () => {
        const videoSections = document.querySelectorAll('[data-video-observer]');
        if (videoSections) {
            videoSections.forEach((section) => {
                var _a, _b;
                const desktopVideo = ((_a = section.attributes['data-src-desktop']) === null || _a === void 0 ? void 0 : _a.value) || null;
                const mobileVideo = ((_b = section.attributes['data-src-mobile']) === null || _b === void 0 ? void 0 : _b.value) || null;
                const threshold = 0;
                let isPaused = false;
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !section.src) {
                            if (window.innerWidth < breakPoint && mobileVideo) {
                                section.src = mobileVideo;
                            }
                            else if (desktopVideo) {
                                if (window.innerWidth < breakPoint) {
                                    section.src = null;
                                    section.removeAttribute('src');
                                }
                                else {
                                    section.src = desktopVideo;
                                }
                            }
                            window.addEventListener('resize', () => {
                                switchMedia(section, desktopVideo, mobileVideo);
                            });
                        }
                        if (entry.intersectionRatio < threshold) {
                            section.pause();
                            isPaused = true;
                        }
                        else if (isPaused) {
                            section.play().catch((error) => {
                                if (error.name === 'NotAllowedError') {
                                    section.style.display = 'none';
                                }
                            });
                            isPaused = false;
                        }
                    });
                }, {
                    root: null,
                    rootMargin: '20px',
                    threshold: threshold,
                });
                observer.observe(section);
            });
        }
    };
    init();
};
export { videoObserver };
